import Vue from "vue";
import Router from "vue-router";
import store from "../store";


import App from '@/App.vue'
import Home from "@/components/home";
import Blog from "@/components/blog";
import BlogPost from "@/components/blog-post";
import Page from "@/components/page";

Vue.use(Router);

export default new Router({
  //mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/news",
      name: "blog",
      component: Blog
    },
    {
      path: '/news/:slug',
      name: 'blog-post',
      component: BlogPost
    },
    {
      path: '/:slug',
      name: 'page',
      component: Page
    }
  ]
});
